import {
  logoDividerStyle,
  logoPrimaryTextStyle,
  logoRowStyle,
  logoGradientTextStyle,
  textLogoA11yProps,
  type TextLogoProps,
} from './textLogoStyles'

/** Charcoal "Uniquely" company mark */
export function UniquelyNDCompanyLogo({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'Uniquely',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoPrimaryTextStyle(size, 400), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      Uniquely
    </span>
  )
}

/** Gradient "ND" product mark */
export function UniquelyNDProductLogo({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'ND',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoGradientTextStyle(size, 600), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      ND
    </span>
  )
}

/** Horizontal "Uniquely ND" full lockup */
export function UniquelyNDFullLogo({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'Uniquely ND',
}: TextLogoProps) {
  // LENS renders a touch smaller than LINA — at equal font-size, solid black
  // text optically reads larger next to the lighter-weight gradient wordmark.
  const productSize = Math.round(size * 0.9)

  return (
    <span
      className={className}
      style={{ ...logoRowStyle(), ...style }}
      {...textLogoA11yProps(ariaLabel)}
    >
      <UniquelyNDCompanyLogo size={productSize} decorative />
      <span aria-hidden="true" style={logoDividerStyle(size)} />
      <UniquelyNDProductLogo size={size} decorative />
    </span>
  )
}
